import { useState, useEffect } from 'react';
import { api } from '../api/client';
import type { CabinetInfo } from '../types';

/**
 * Хук для загрузки данных личного кабинета (компания + менеджер)
 * Загружает один раз при монтировании
 */
export function useCabinet() {
  const [cabinet, setCabinet] = useState<CabinetInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const data = await api.company.getInfo();
        if (!cancelled) {
          setCabinet(data);
          setError(null);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Ошибка загрузки');
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, []);

  return { cabinet, isLoading, error };
}
